import { StateCreator } from 'zustand';
import { Middleware } from './common';

export interface SaveChangesConfirmationDialogSlice {
  saveChangesConfirmationDialog?: SaveChangesConfirmationDialogState;
  openSaveChangesConfirmationDialog: (saveChangesConfirmationDialog: SaveChangesConfirmationDialogState) => void;
  closeSaveChangesConfirmationDialog: () => void;
}

export interface SavedViewSaveOptions {
  /** When updating the default view, optionally set or update its name. */
  defaultViewName?: string;
  /** When creating a new saved view, provide its name. */
  createSavedView?: { name: string };
}

export interface SaveChangesConfirmationDialogState {
  onSaveChanges: (
    saveDefaultTimeRange: boolean,
    saveDefaultVariables: boolean,
    savedViewOptions?: SavedViewSaveOptions
  ) => void;
  onCancel: () => void;
  isSavedTimeRangeModified: boolean;
  isSavedVariableModified: boolean;
  description?: string;
}

export const createSaveChangesDialogSlice: StateCreator<
  SaveChangesConfirmationDialogSlice,
  Middleware,
  [],
  SaveChangesConfirmationDialogSlice
> = (set) => ({
  isOpen: false,

  openSaveChangesConfirmationDialog(dialog) {
    set(
      (state) => {
        state.saveChangesConfirmationDialog = dialog;
      },
      false,
      'openSaveChangesConfirmationDialog'
    );
  },

  closeSaveChangesConfirmationDialog() {
    set(
      (state) => {
        state.saveChangesConfirmationDialog = undefined;
      },
      false,
      'closeSaveChangesConfirmationDialog'
    );
  },
});
